<template>
  <div class="reports">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <div class="page-header">
            <router-link
              :to="{ path: '/tickets/completed', append: true }"
              class="btn btn-primary btn-lg float-right my-1 mx-1">
              <i class="far fa-check-square fa-fw mr-2"></i> Completed
            </router-link>
            <router-link
              :to="{ path: '/tickets/outstanding', append: true }"
              class="btn btn-primary btn-lg float-right my-1 mx-1">
              <i class="far fa-check-square fa-fw mr-2"></i> Outstanding
            </router-link>
            <router-link
              v-if="$route.meta.allowNew"
              :to="{ path: '/tickets/new', append: true }"
              class="btn btn-primary btn-lg float-right my-1 mx-1">
              <i class="far fa-file fa-fw mr-2"></i> New
            </router-link>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <transition name="fly">
            <div v-if="$route.meta.showSearch"
              @click="toggleSearch()"
              v-show="searchHidden">
              <p class="form-control text-muted fake-input interactive-cursor">
                Search...
                <span class="fa fa-search float-right"></span>
              </p>
            </div>
          </transition>
          <div v-show="!searchHidden">
            <vue-form ref="form"
              @submit.prevent="search()"
                :sections="cardsSearchForm"
                :options="{
                  submit: 'Search',
                  submitting: 'Searching...',
                  permalink: $route.meta.vueCards,
                  method: 'search',
                  fullWidth: true
                }">
                <span slot="title">
                <i class="fa fa-search fa-fw"></i> Search Tickets
                <span
                  class="fa fa-times float-right fa-lg text-danger interactive-cursor"
                  @click="toggleSearch()">
                </span>
              </span>
              <div class="col" slot="actions">
                <button class="btn btn-info" type="button" @click="search()">
                  <i class="fa fa-search fa-fw"></i> Search
                </button>
              </div>
            </vue-form>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <paging-input ref="paging"
            @change="changePage"
            :options="{
            current: (loadedCards.offset + loadedCards.limit) / loadedCards.limit,
            totalResults: loadedCards.count,
            limit: loadedCards.limit
          }">
          </paging-input>
            <template v-if="cards.rows.length > 0">
              <template v-if="cards.permalink === $route.meta.vueCards">
                <div
                v-for="(object, i) in cards.rows"
                :class="{ 'bg-light': i % 2 == 0 }"
                :key="i">
                  <component :is="parseType($route.meta.vueCards)" :object="object">
                  </component>
                </div>
              </template>
            </template>
            <p class="alert alert-danger text-strong" v-if="!cards.rows.length">
              <strong>{{ cards.searchForm.noResults }}</strong>
            </p>
          <paging-input ref="paging"
            @change="changePage"
            :options="{
              current: (loadedCards.offset + loadedCards.limit) / loadedCards.limit,
              totalResults: loadedCards.count,
              limit: loadedCards.limit
            }">
          </paging-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PagingInput from '@/components/inputs/PagingInput'
import { mapGetters } from 'vuex'
import VueForm from '@/components/Form'
import { LOAD_CARDS, OPEN_ERROR_MODAL } from '@/vuex/types'
import Ticket from '@/components/cards/Ticket'
export default {
  name: 'Cards',
  components: {
    PagingInput,
    VueForm,
    Ticket
  },
  data () {
    return {
      searchOffset: 0,
      searchHidden: true,
      sortDirection: false,
      sortColumn: false,
      newSearch: true
    }
  },
  computed: {
    ...mapGetters([
      'loadedCards',
      'cards',
      'cardsSearchForm'
    ])
  },
  watch: {
    $route () {
      this.createNewSearch()
    }
  },
  mounted () {
    this.createNewSearch()
  },
  methods: {
    async toggleSearch () {
      this.searchHidden = !this.searchHidden
      if (!this.searchHidden) {
        await this.$nextTick()
        this.$refs.form.$el.querySelectorAll('input[type=text]')[0].focus()
      }
    },
    async createNewSearch () {
      try {
        this.searchOffset = 0
        await this.$store.dispatch(LOAD_CARDS, {
          cards: this.$route.meta.vueCards,
          searchForm: [],
          sortDirection: this.sortDirection,
          sortColumn: this.sortColumn,
          offset: this.searchOffset,
          limit: this.loadedCards.limit,
          newSearch: true
        })
      } catch (err) {
        this.$store.dispatch(OPEN_ERROR_MODAL, err)
      }
    },
    async search () {
      await this.$refs.form.validateForm()
      if (this.$refs.form.validForm) {
        let searchForm = this.cardsSearchForm
        searchForm.splice(-1, 1)
        try {
          await this.$store.dispatch(LOAD_CARDS, {
            cards: this.$route.meta.vueCards,
            searchForm,
            sortDirection: this.sortDirection,
            sortColumn: this.sortColumn,
            offset: this.searchOffset,
            limit: this.loadedCards.limit,
            newSearch: this.newSearch
          })
        } catch (err) {
          this.$store.dispatch(OPEN_ERROR_MODAL, err)
        }
      }
    },
    async changePage (page) {
      this.searchOffset = (page - 1) * this.loadedCards.limit
      await this.search()
    },
    parseType (type) {
      switch (type) {
        case 'tickets':
        case 'completedTickets':
          return 'ticket'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Cards.vue